export default "__VITE_ASSET__DpkZy7xe__"